import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-phone-input-2/lib/bootstrap.css"; // phone input styles
import "../styles/Login.css";
import reactLogo from "../assets/policy-logo.png";
import PhoneInput from "react-phone-input-2"; // flag phone input
import AnimatedBanner from "../components/AnimatedBanner";
import { sendOtp, verifyOtp } from "../services/OtpVerification";
import CONFIG from "../utils/config";

console.log(CONFIG.ENV);      // "dev" / "local" / "uat" / "live"
console.log(CONFIG.BASE);     // API base
console.log(CONFIG.APPROVAL); // approval API
console.log(CONFIG.WHATSAPPURL);      // URL API

const Login = () => {
  const [qid, setQid] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [policyNumber, setPolicyNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedIdType, setSelectedIdType] = useState("QID");
  const [isChecked, setIsChecked] = useState(false);
  const navigate = useNavigate();
  const isLive = CONFIG.ENV === "live";
  const handleCheckboxChange = (e) => setIsChecked(e.target.checked);
  const [otpLoading, setOtpLoading] = useState(false);

  const otpInputRef = useRef(null);
  const generateOTP = () => {
    const otpLength = 6;
    let otpValue = "";
    for (let i = 0; i < otpLength; i++) {
      otpValue += Math.floor(Math.random() * 10);
    }
    setOtp(otpValue);
    toast.success("OTP generated!", { position: "top-right", autoClose: 2000 });
  };

  // const handleSendOtp = async () => {
  //   if (!mobileNumber || mobileNumber.trim() === "") {
  //     toast.error("Please enter a mobile number!");
  //     return;
  //   }
  //   try {
  //     const result = await sendOtp(mobileNumber,qid);
  //     if (result.success){
  //       toast.success("OTP sent successfully!");
  //       console.log("SMS API Response:", result);
  //     }else{
  //       // toast.error(`${result.message}`);
  //       toast.error('Mobile number is not available!');
  //       console.log("SMS API Response:", result.message);
  //     }
      
  //   } catch (err) {
  //     toast.error("Failed to send OTP");
  //     console.error("SMS API Error:", err);
  //   }
  // };

  const handleSendOtp = async () => {
    

    if (!mobileNumber || mobileNumber.trim() === "") {
      toast.error("Please enter a mobile number!");
      return;
    }
  
    try {
      // pick the right value based on selection
      const idValue = selectedIdType === "QID" ? qid.trim() : policyNumber.trim();
  
      const result = await sendOtp(mobileNumber, idValue);
  
      if (result.success) {
        toast.success("OTP sent successfully!");
        console.log("SMS API Response:", result);
      } else {
        toast.error("Mobile number is not available!");
        console.log("SMS API Response:", result.message);
      }
    } catch (err) {
      toast.error("Failed to send OTP");
      console.error("SMS API Error:", err);
    }
  };
  
  



const handleFunction = async () => {

  if (
    (selectedIdType === "QID" && !qid.trim()) ||
    (selectedIdType === "Policy Number" && !policyNumber.trim()) 
   
  ) {
    toast.error("Please enter a valid QID / Policy No!", {
      position: "top-right",
      autoClose: 2000,
    });
    return;
  }
  if (!mobileNumber || mobileNumber.trim() === "") {
    toast.error("Please enter a mobile number!");
    return;
  }
  try {
    setOtpLoading(true); // show loader
    const result = isLive 
      ? await handleSendOtp(mobileNumber) 
      : await generateOTP(mobileNumber);
    console.log("SMS API Response:", result);
    if (otpInputRef.current) {
      otpInputRef.current.focus();
    }
  } catch (err) {
    toast.error("Failed to send OTP");
    console.error("SMS API Error:", err);
  }finally {
    setOtpLoading(false); // hide loader after done
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      (selectedIdType === "QID" && !qid.trim()) ||
      (selectedIdType === "Policy Number" && !policyNumber.trim()) ||
      !mobileNumber ||
      mobileNumber.replace(/\D/g, "").length < 8
    ) {
      toast.error("Please enter a valid QID / Policy Number and Mobile Number!", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }

    setLoading(true);

    try {

      //first process
      if(isLive){
        const idValue = selectedIdType === "QID" ? qid.trim() : policyNumber.trim();
const otpResult = await verifyOtp(mobileNumber, otp, idValue);

     // const otpResult = await verifyOtp(mobileNumber, otp,qid);
      if (!otpResult.success) {
        toast.error("Invalid OTP, please try again!");
        setLoading(false);
        return;
      }
      }
      //second process
      let requestBody = { mobileNumber };
      if (selectedIdType === "QID") requestBody.qid = qid.trim();
      else requestBody.policyNumber = policyNumber.trim();

      const response = await fetch(`${CONFIG.BASE}/insurance/fetch-all`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) throw new Error(`Failed to fetch policy details. Status: ${response.status}`);

      const policies = await response.json();

      if (!Array.isArray(policies) || policies.length === 0) {
        toast.error("No records found!", { position: "top-right", autoClose: 2000 });
        setLoading(false);
        return;
      }

      const policyIds = policies.map((p) => p.id);

      if (policyIds.length === 1) {
        navigate("/motor", { state: { id: policyIds[0] } });
      } else {
        navigate("/motorv2", { state: { id: policyIds } });
      }

    } catch (error) {
      console.error("Error fetching policy details:", error);
      toast.error("Error fetching policy details. Please try again!", {
        position: "top-right",
        autoClose: 2000,
      });
    }

    setLoading(false);
  };

  return (
    <div className="container-fluid login-container overflow-hidden">
      <div className="row d-flex justify-content-center align-items-center min-vh-100">
        <div className="col-sm-12">
          <a className="d-flex justify-content-center align-items-center mb-4 text-decoration-none" href="/">
            <img
              className="me-2 react-logo"
              src={reactLogo}
              alt="QIC Logo"
              width="160"
              height="80"
            />
          </a>
          <AnimatedBanner />
          <div className="card animated-card">
            <div className="card-body p-4 p-sm-5">
              <h5 className="text-center mb-4 fw-bold">
                <span className="font-sans-serif text-decoration-none fw-bolder fs-4" style={{ color: "#1d2671" }}>
                  <span style={{ color: "#c33764" }}>OneClick</span> Policy Renewal
                </span>
              </h5>
              <form onSubmit={handleSubmit}>
                {/* Radio buttons */}
                <div className="d-flex justify-content-evenly align-items-center mb-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={selectedIdType === "QID"}
                      onChange={() => setSelectedIdType("QID")}
                    />
                    <label className="form-check-label">QID</label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={selectedIdType === "Policy Number"}
                      onChange={() => setSelectedIdType("Policy Number")}
                    />
                    <label className="form-check-label">Policy Number</label>
                  </div>
                </div>

                {/* QID or Policy Number */}
                <div className="mb-3">
                  <input
                    className="form-control"
                    type="text"
                    placeholder={selectedIdType === "QID" ? "xxxxxxxxxxx" : "xxxxxxxx"}
                    value={selectedIdType === "QID" ? qid : policyNumber}
                    onChange={(e) =>
                      selectedIdType === "QID"
                        ? setQid(e.target.value)
                        : setPolicyNumber(e.target.value)
                    }
                  />
                </div>

                {/* Mobile number with flag */}
                <div className="mb-3">
                  <PhoneInput
                    country={"qa"} // default Qatar
                    value={mobileNumber}
                    onChange={(phone) => setMobileNumber(phone)}
                    inputProps={{
                      name: "mobile",
                      required: true,
                      autoFocus: false,
                    }}
                    enableSearch={true}
                    countryCodeEditable={false}
                  />
                </div>

                {/* OTP */}
                <div className="input-group mb-3">
                  <input
                    className="form-control"
                    type="text"
                    placeholder="OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    ref={otpInputRef}  
                  />
                  <button
                    className="btn btn-outline-danger fw-semibold"
                    type="button"
                    // onClick={generateOTP}
                    onClick={handleFunction}
                    disabled={otpLoading}
                  >
                    {otpLoading ? (
    <>
      <span
        className="spinner-border spinner-border-sm me-2"
        role="status"
        aria-hidden="true"
      ></span>
      Sending...
    </>
  ) : (
    "Get OTP"
  )}
                  </button>
                </div>

                {/* Terms */}
                <div className="form-check mb-3">
                  <input
                    className="form-check-input border-2 border-dark"
                    type="checkbox"
                    checked={isChecked}
                    onChange={handleCheckboxChange}
                  />
                  <label className="form-check-label">I Agree to Terms & Conditions</label>
                </div>

                {/* Submit */}
                <div className="mb-3">
                  <button
                    className="btn renewal-opt__btn-primary d-block w-100 mt-3"
                    type="submit"
                    disabled={!isChecked || loading}
                  >
                    {loading ? <span className="spinner-border spinner-border-sm"></span> : "Get Policy"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
